<template>
  <div style="height:100%;width:100%">
    <div class="con-wrap" v-if="isActive == 'detail'">
      <div class="map-wrap">
        <div class="top">
          <el-button type="primary" @click="gotoPowerTable">返回</el-button>
        </div>
        <div id="map-box"></div>
        <div class="powerData">
          <div>
            <span>车牌号：</span>
            <span>{{ plateNum }}</span>
          </div>
          <div>
            <span>发电开始：</span>
            <span>{{ powerData.startTime }}</span>
          </div>
          <div>
            <span>发电结束：</span>
            <span>{{ powerData.endTime }}</span>
          </div>
          <div>
            <span>发电量：</span>
            <span>{{ powerData.capacity }}KW·H</span>
          </div>
          <div>
            <span>发电时长：</span>
            <span>{{ powerData.duration }}</span>
          </div>
          <div>
            <span>发电油耗：</span>
            <span>{{ powerData.oil }}L</span>
          </div>
        </div>
        <div class="echarts">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="总正相有功功率" name="first">
              <div id="echarts" class="echartsBox"></div>
            </el-tab-pane>
            <el-tab-pane label="车辆转速" name="second">
              <div id="speedEcharts" class="echartsBox"></div>
            </el-tab-pane>
          </el-tabs>
          <div class="more" @click="checkMore">
            查看更多数据
            <span class="iconfont icon-drop-down query-icons"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isActive == 'more'">
      <power-more :id="id" :vin="vin" @gotoDetail="gotoDetail"></power-more>
    </div>
  </div>
</template>

<script>
import PowerMore from "./PowerMore";
import AMap from "AMap";
export default {
  name: "PowerDetail",
  components: {
    PowerMore,
  },
  data() {
    return {
      activeName: "first",
      switch: true,
      isActive: "detail",
      myChart: "",
      vin: null,
      id: null,
      datax: [],
      datay: [],
      speedDatax: [],
      speedDatay: [],
      map: null,
      scale: null,
      marker: null,
      faultMarker: null,
      geocoder: null,
      infoWindow: null,
      powerData: {},
      plateNum: null,
      baseStationList: [],
      baseStationMarks: null,
      stationBankList: [],
      faultStationBank: {},
      faultStationBankMarks: null,
      stationBankMarks: null,
      subjectNum: "",
    };
  },
  created() {
    this.vin = this.$route.params.vin || sessionStorage.getItem("powerVin");
    this.id = parseInt(
      this.$route.params.id || sessionStorage.getItem("powerId")
    );
    this.subjectNum =
      this.$route.params.subjectNum ||
      sessionStorage.getItem("statisticsSubjectNum");
    sessionStorage.setItem("powerVin", this.vin);
    sessionStorage.setItem("powerId", this.id);
    sessionStorage.setItem("statisticsSubjectNum", this.subjectNum);
  },
  mounted() {
    this.init();
    this.getPlateNum();
    this.getLocation();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      let _this = this;
      let obj = {
        vin: _this.vin,
        startTime: _this.powerData.startTime,
        endTime: _this.powerData.endTime,
      };
      if (_this.activeName == "first") {
        _this.getDynamokChart(obj);
      } else {
        _this.getSpeedkChart(obj);
      }
    },
    checkMore() {
      this.isActive = "more";
    },
    gotoDetail() {
      this.isActive = "detail";
      this.$nextTick(() => {
        this.init();
        this.getLocation();
      });
    },
    gotoPowerTable() {
      let pathUrl = sessionStorage.getItem("pathUrl");
      console.log(pathUrl);
      if (pathUrl == "/PowerDetail") {
        this.$router.push({
          name: "PowerDetail",
          params: {
            vin: this.vin,
            subjectNum: this.subjectNum,
            currentPage: sessionStorage.getItem("powerDetailCurrPage"),
          },
        });
       
      } else {
         this.$router.push({
          name: "VehicleInfo",
          params: {
            vin: this.vin,
            active: "power",
            currentPage: sessionStorage.getItem("powerCurrPage"),
            powerType: sessionStorage.getItem("powerType"),
          },
        });
      }
    },
    // 查车牌号
    async getPlateNum() {
      let _this = this;
      let id = this.id;
      let { data: res } = await _this.$axios.get(
        `/api/vehicle/details/dynamo/counts/more/${id}`
      );
      if (res.code == 1) {
        _this.plateNum = res.data.plateNum;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查询发电数据和定位
    async getLocation() {
      let _this = this;
      let id = _this.id;
      let { data: res } = await _this.$axios.get(
        `/api/vehicle/details/dynamo/counts/details/${id}`
      );
      if (res.code == 1) {
        _this.baseStationList = res.data.stationList;
        _this.stationBankList = res.data.stationBankList;
        _this.faultStationBank = res.data.stationGeo;
        _this.powerData = res.data;
        _this.getCharts();
        //清理覆盖物
        if (_this.marker) {
          _this.map.remove(_this.marker);
        }
        if (_this.powerData.longitude && _this.powerData.latitude) {
          _this.marker = new AMap.Marker({
            position: [_this.powerData.longitude, _this.powerData.latitude],
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
          });
          _this.map.setCenter([
            _this.powerData.longitude,
            _this.powerData.latitude,
          ]);
          _this.map.add(_this.marker);
          _this.addBaseStationMarks();
          _this.addStationBankMarks();
          _this.addFaultStationBankMarks();
          _this.marker.on("click", function() {
            _this.geocoder.getAddress(
              [_this.powerData.longitude, _this.powerData.latitude],
              function(status, result) {
                if (status === "complete" && result.info === "OK") {
                  var address = result.regeocode.formattedAddress;
                  var info = [];
                  info.push(
                    "<p class='input-item'>当前位置 :" + address + "</p>"
                  );
                  _this.infoWindow = new AMap.InfoWindow({
                    offset: new AMap.Pixel(0, -38),
                    anchor: "bottom-center",
                    closeWhenClickMap: true,
                    autoMove: true,
                    content: info.join(""), //使用默认信息窗体框样式，显示信息内容
                  });
                  if (_this.switch) {
                    _this.infoWindow.open(_this.map, [
                      _this.powerData.longitude,
                      _this.powerData.latitude,
                    ]);
                  } else {
                    _this.infoWindow.close();
                  }
                  _this.switch = !_this.switch;
                  // _this.infoWindow.open(_this.map,[_this.powerData.longitude,_this.powerData.latitude])
                } else {
                  _this.$message.warning("根据此经纬度未查询到地址");
                }
              }
            );
          });
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 添加故障基站图标
    addFaultStationBankMarks() {
      let _this = this;
      let style = _this.faultStationBank.style;
      let faultStationBankData = [];
      faultStationBankData.push(_this.faultStationBank);
      let icon = null;
      switch (style) {
        case 1:
          icon = require("@/assets/images/monitor/faultBaseStation.png");
          break;
        case 2:
          icon = require("@/assets/images/monitor/bank/ABOC_error.png");
          break;
        case 3:
          icon = require("@/assets/images/monitor/bank/ICBC_error.png");
          break;
        case 4:
          icon = require("@/assets/images/monitor/bank/BOC_error.png");
          break;
        case 5:
          icon = require("@/assets/images/monitor/bank/CCB_error.png");
          break;
        case 6:
          icon = require("@/assets/images/monitor/bank/BC_error.png");
          break;
      }
      _this.faultStationBankMarks = new AMap.MassMarks(faultStationBankData, {
        zIndex: 200, // 海量点图层叠加的顺序
        zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
        cursor: "pointer",
        style: {
          url: icon,
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(24, 28),
        },
      });
      let faultStationBankMarker = new AMap.Marker({
        content: " ",
        map: _this.map,
      });
      AMap.event.addListener(_this.faultStationBankMarks, "mouseover", function(
        e
      ) {
        faultStationBankMarker.setPosition(e.data.lnglat);
        faultStationBankMarker.setLabel({ content: e.data.name });
      });
      AMap.event.addListener(_this.faultStationBankMarks, "mouseout", function(
        e
      ) {
        faultStationBankMarker.setPosition(e.data.lnglat);
        faultStationBankMarker.setLabel({ content: "" });
      });
      _this.faultStationBankMarks.setMap(_this.map);

      // _this.faultMarker = new AMap.Marker({
      //     icon: icon,
      //     position: _this.faultStationBank.lnglat,
      //     cursor: "pointer",
      // })
      // _this.map.add(_this.faultMarker)
      // let bankStationMarker = new AMap.Marker({ content: " ", map: _this.map })
      // AMap.event.addListener(_this.faultMarker, "mouseover", function(e) {
      //   bankStationMarker.setPosition(e.data.lnglat)
      //   bankStationMarker.setLabel({ content: e.data.name })
      // })
      // AMap.event.addListener(_this.faultMarker, "mouseout", function(e) {
      //   bankStationMarker.setPosition(e.data.lnglat)
      //   bankStationMarker.setLabel({ content: "" })
      // })
    },
    // 添加基站图标
    addBaseStationMarks() {
      let _this = this;
      let style = {
        url: require("@/assets/images/base-station.png"),
        anchor: new AMap.Pixel(6, 6),
        size: new AMap.Size(20, 30),
      };
      _this.baseStationMarks = new AMap.MassMarks(_this.baseStationList, {
        zIndex: 200, // 海量点图层叠加的顺序
        zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
        cursor: "pointer",
        style: style,
      });
      let baseStationMarker = new AMap.Marker({ content: " ", map: _this.map });
      AMap.event.addListener(_this.baseStationMarks, "mouseover", function(e) {
        baseStationMarker.setPosition(e.data.lnglat);
        baseStationMarker.setLabel({ content: e.data.name });
      });
      AMap.event.addListener(_this.baseStationMarks, "mouseout", function(e) {
        baseStationMarker.setPosition(e.data.lnglat);
        baseStationMarker.setLabel({ content: "" });
      });
      _this.baseStationMarks.setMap(_this.map);
    },
    //添加银行图标
    addStationBankMarks() {
      let _this = this;
      let styleArr = [
        {
          url: require("@/assets/images/base-station.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(20, 30),
        },
        {
          url: require("@/assets/images/base-station.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(20, 30),
        },
        {
          url: require("@/assets/images/monitor/bank/ABOC.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(24, 28),
        },
        {
          url: require("@/assets/images/monitor/bank/ICBC.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(24, 28),
        },
        {
          url: require("@/assets/images/monitor/bank/BOC.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(24, 28),
        },
        {
          url: require("@/assets/images/monitor/bank/CCB.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(24, 28),
        },
        {
          url: require("@/assets/images/monitor/bank/BC.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(24, 28),
        },
      ];
      _this.stationBankMarks = new AMap.MassMarks(_this.stationBankList, {
        zIndex: 100, // 海量点图层叠加的顺序
        zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
        style: styleArr,
      });
      let bankStationMarker = new AMap.Marker({ content: " ", map: _this.map });
      AMap.event.addListener(_this.stationBankMarks, "mouseover", function(e) {
        bankStationMarker.setPosition(e.data.lnglat);
        bankStationMarker.setLabel({ content: e.data.name });
      });
      AMap.event.addListener(_this.stationBankMarks, "mouseout", function(e) {
        bankStationMarker.setPosition(e.data.lnglat);
        bankStationMarker.setLabel({ content: "" });
      });
      _this.stationBankMarks.setMap(_this.map);
    },
    // 查询功率和转速
    getCharts() {
      let _this = this;
      let obj = {
        vin: _this.vin,
        startTime: _this.powerData.startTime,
        endTime: _this.powerData.endTime,
        deviceId: _this.powerData.deviceId,
      };
      _this.getDynamokChart(obj);
    },
    async getDynamokChart(obj) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/dynamo/counts/kChart",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.datax = [];
        _this.datay = [];
        res.data.map((item) => {
          if (item.forwardPower != 65535) {
            _this.datax.push(item.ts);
            _this.datay.push(item.forwardPower);
          }
        });
        _this.$nextTick(() => {
          _this.initCharts(
            "echarts",
            "总正相有功功率",
            _this.datax,
            _this.datay
          );
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getSpeedkChart(obj) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/engine/speed/kChart",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.speedDatax = [];
        _this.speedDatay = [];
        res.data.map((item) => {
          if (item.forwardPower != 65535) {
            _this.speedDatax.push(item.ts);
            _this.speedDatay.push(item.emsEngineSpeed);
          }
        });
        _this.$nextTick(() => {
          _this.initCharts(
            "speedEcharts",
            "车辆转速",
            _this.speedDatax,
            _this.speedDatay
          );
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    init() {
      this.map = new AMap.Map("map-box", {
        resizeEnable: true,
        zoom: 15,
      });
      this.geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });
    },
    initCharts(id, name, datax, datay) {
      let _this = this;
      let showed = datay.length ? false : true;
      // let max=datax[datax.length-1]
      this.myChart = this.$echarts.init(document.getElementById(id));
      this.myChart.setOption({
        title: {
          show: showed,
          text: "暂无数据...",
          left: "center",
          top: "center",
          textStyle: {
            fontWeight: "normal",
            color: "#999999",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              backgroundColor: "#00FAC0",
            },
          },
        },
        grid: {
          left: "1%",
          right: "4%",
          bottom: "8%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: datax,
          splitLine: {
            show: false,
          },
          axisLabel: {
            showMaxLabel: true,
            show: true,
            formatter: function(value) {
              var date = value.split(" ")[0];
              var time = value.split(" ")[1];
              return time + "\n" + date;
            },
          },
        },
        yAxis: {
          nameTextStyle: {
            color: "#97ABEA",
            fontSize: 12,
          },
          type: "value",
          boundaryGap: [0, "100%"],
          splitLine: {
            show: false,
          },
        },
        dataZoom: [
          {
            show: true,
            type: "slider",
            xAxisIndex: 0,
            filterMode: "filte",
          },
          {
            type: "inside",
            xAxisIndex: 0,
            filterMode: "filte",
          },
        ],
        series: [
          {
            name: name,
            data: datay,
            type: "line",
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgb(255, 70, 131)",
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 158, 68)",
                },
                {
                  offset: 1,
                  color: "rgb(255, 70, 131)",
                },
              ]),
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
          },
        ],
      });
      window.addEventListener("resize", () => {
        _this.myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav-scroll {
  padding-left: 20px;
}
.con-wrap {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  position: relative;
}
.top {
  margin-bottom: 20px;
}
.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}
.map-wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .powerData {
    position: absolute;
    left: 20px;
    top: 70px;
    width: 260px;
    height: 195px;
    background: #000000;
    opacity: 0.8;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    padding: 10px 20px;
    box-sizing: border-box;
    line-height: 30px;
  }
  .echarts {
    width: calc(100% - 2px);
    background: #fafafa;
    box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.3);
    position: absolute;
    left: 1px;
    bottom: 1px;
    box-sizing: border-box;
    .echartsBox {
      width: 100%;
      height: 240px;
      background: #fff;
    }
    .more {
      color: #0094ff;
      position: absolute;
      cursor: pointer;
      right: 15px;
      top: 10px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      .query-icons {
        display: inline-block;
        transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
      }
    }
  }
}
#map-box {
  width: 100%;
  height: calc(100% - 52px);
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
}

/deep/ .amap-info-content {
  .amap-info-close {
    display: none;
  }
  .input-item {
    line-height: 25px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}
</style>
